import { Partner } from "@/models";

import { isB2CPartner } from "../partners";

/**
 * Determines if the SDOH questions should be asked.
 *
 * @param partnerInfo used to determine if the partner is a B2C partner
 * @returns
 */
export const shouldAskSDOH = (partnerInfo: Partner | null) => {
  if (partnerInfo?.id === undefined) {
    return false;
  }

  return !isB2CPartner(partnerInfo);
};
